<template>
  <v-slide-x-transition>
    <v-chip
      v-if="isDisconnected"
      small
      color="warning"
      text-color="white"
      class="ml-2 connection-chip"
      @click="showReloadButton ? reload() : null"
    >
      <v-icon
        small
        left
      >
        {{ icons.mdiWifiOff }}
      </v-icon>
      {{ message }}
    </v-chip>
  </v-slide-x-transition>
</template>

<script>
import {
  computed, ref, watch, onBeforeUnmount, getCurrentInstance,
} from '@vue/composition-api'
import { mdiWifiOff } from '@mdi/js'

const RELOAD_TIMEOUT_MS = 30000

export default {
  name: 'ConnectionBanner',
  setup() {
    const vm = getCurrentInstance().proxy
    const showReloadButton = ref(false)
    let reloadTimer = null

    const isDisconnected = computed(() => vm.$store.getters['websocket/isAnyDisconnected'])

    const message = computed(() => {
      if (showReloadButton.value) {
        return '通信切断 - タップでリロード'
      }

      return '再接続中...'
    })

    const clearReloadTimer = () => {
      if (reloadTimer) {
        clearTimeout(reloadTimer)
        reloadTimer = null
      }
    }

    watch(isDisconnected, newVal => {
      if (newVal) {
        clearReloadTimer()
        reloadTimer = setTimeout(() => {
          showReloadButton.value = true
        }, RELOAD_TIMEOUT_MS)
      } else {
        clearReloadTimer()
        showReloadButton.value = false
      }
    })

    onBeforeUnmount(() => {
      clearReloadTimer()
    })

    const reload = () => {
      window.location.reload()
    }

    return {
      isDisconnected,
      showReloadButton,
      message,
      reload,
      icons: { mdiWifiOff },
    }
  },
}
</script>

<style lang="scss" scoped>
.connection-chip {
  position: fixed;
  top: 16px;
  left: 350px;
  z-index: 300;
  cursor: default;
  font-weight: 500;

  &:hover {
    opacity: 0.9;
  }
}
</style>
